var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.767 1L10.635 2.137L11.935 3.444H9.068V5.052H11.938L10.635 6.36L11.767 7.497L15 4.248L11.767 1ZM3.098 3.068H5.433V5.428H3.098V3.068ZM1.598 1.568H6.933V6.928H1.598V1.568ZM10.567 10.572H12.902V12.932H10.567V10.572ZM9.067 9.072H14.402V14.432H9.067V9.072ZM5.365 9.641L4.233 8.504L1 11.752L4.233 15L5.365 13.863L4.065 12.556H6.933V10.95H4.063L5.365 9.641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAi);
export default __webpack_public_path__ + "static/media/sidebar-ai.eee1f5e59aa3d483b5d373dd1c4cddaf.svg";
export { ForwardRef as ReactComponent };